import { createSelector } from "reselect";
import { Option } from "shared/model/Option";

import { State } from "./State";

const getApiSpecs = (state: State) => state.apiSpecs;

export const getApiSpecOperationSelectorModel = createSelector(
    [getApiSpecs],
    (apiSpecs) => {
        return apiSpecs
            .filter((spec) => !!spec.activeVersion) // filter out specs for only orphaned processes
            .map((spec) => {
                return {
                    label: spec.name,
                    options: spec.activeVersion?.oasViewModel.operations
                        .map((pathInfo) => ({
                            value: { specId: spec.id, pathKey: pathInfo.path, method: pathInfo.operation },
                            label: `${pathInfo.operation.toUpperCase()} ${pathInfo.path}`,
                            metadata: pathInfo.description,
                        }) as ApiSpecOperationSelectModel)
                };
            });
    }
);

export interface ApiSpecOperationId {
    specId: number;
    pathKey: string;
    method: string;
}

export interface ApiSpecOperationSelectModel extends Option {
    value: ApiSpecOperationId;
    label: string;
    metadata: string;
}

export interface ApiSpecOperationSelectModelBySpec {
    label: string;
    options: ApiSpecOperationSelectModel[] | undefined;
}
